<template>
  <v-dialog v-model="showDialog" max-width="290" persistent>
    <v-card
      ><v-card-title class="headline">Confirm</v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click.native="confirmAction"
          :loading="loading"
          color="error"
          small
          >Remove</v-btn
        >
        <v-btn
          @click.native="declineAction"
          :loading="loading"
          color="info"
          small
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDeleteDialog',
  props: {
    showDialog: {
      default: false,
    },
    unpublishedAction: {
      type: Function,
    },
    confirmAction: {
      type: Function,
    },
    loading: {
      default: false,
    },
    closeDialog: {
      type: Function,
    },
  },
  methods: {
    declineAction() {
      this.$swal({
        icon: 'info',
        text: 'No changes made.',
      });
      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>
